import { ReactElement, useState } from 'react';

import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { BackrsPDFPreview } from '@backrs_ui/common-ui/src/atoms/BackrsPDFPreview';
import { formatDateToLocaleString } from '@backrs_ui/common-ui/src/utils/dateTime.util';

import { SxProps, Theme, Typography, Box } from '@mui/material';

const NUGGET_STRINGS = appStrings.modules.nugget;

type NuggetOpportunityProps = Readonly<{
  variant:
    | {
        type: 'SMALL';
        deadline: string;
      }
    | {
        type: 'LARGE';
        deadline: string;
        mediaUrl?: string;
      };
}>;

export const NuggetOpportunity = ({ variant }: NuggetOpportunityProps): ReactElement => {
  const [isLargePDFError, setIsLargePDFError] = useState(false);

  // format the date like "12/31/2025"
  const parsedDate = formatDateToLocaleString(variant.deadline);

  if (variant.type === 'SMALL') {
    return variant.deadline ? (
      <Typography variant="body1" sx={bottomTextStyle}>
        <Typography fontWeight="bold" mr={0.5}>
          {NUGGET_STRINGS.opportunitySubtext}
        </Typography>
        {parsedDate}
      </Typography>
    ) : (
      <></>
    );
  }

  return (
    <Box>
      {variant.deadline && (
        <Typography variant="body1" sx={bottomTextStyle}>
          <Typography fontWeight="bold" mr={0.5}>
            {NUGGET_STRINGS.opportunitySubtext}
          </Typography>
          {parsedDate}
        </Typography>
      )}

      {/* if we have a document, attempt to render. If it fails to render, we will hide the PDF preview */}
      {variant.mediaUrl && !isLargePDFError ? (
        <BackrsPDFPreview documentUrl={variant.mediaUrl} onError={() => setIsLargePDFError(true)} />
      ) : null}
    </Box>
  );
};

const bottomTextStyle: SxProps<Theme> = {
  fontFamily: 'Sarabun',
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '20px',
  flexDirection: 'row',
  display: 'flex',
  mt: 3,
};
